import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'

const OZONETEL_URL = 'https://agent.cloudagent.ozonetel.com/'

const OzontelIframe = forwardRef(function OzontelIframe(
  { src = OZONETEL_URL, width = '100%', height = '100%', style, onEvent, ...props },
  ref,
) {
  const iframeRef = useRef(null)
  useImperativeHandle(ref, () => iframeRef.current)

  const onEventRef = useRef(onEvent)
  useEffect(() => { onEventRef.current = onEvent }, [onEvent])

  useEffect(() => {
    const handler = (e) => {
      // Pass all postMessage events — parent decides what to handle
      // (Ozonetel sends from sub-frames so strict origin check breaks it)
      // console.log('[OzontelIframe raw]', e.origin, e.data)
      if (onEventRef.current) {
        onEventRef.current({ time: Date.now(), origin: e.origin, data: e.data })
      }
    }
    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, []) // stable — uses ref

  return (
    <iframe
      ref={iframeRef}
      src={src}
      style={{ width, height, border: 'none', display: 'block', ...style }}
      title="ozonetel-dialer"
      allow="microphone; camera; autoplay"
      {...props}
    />
  )
})

export default OzontelIframe
